import recoveryCodesDownloaded, {
	type RecoveryCodesDownloadedAction,
} from '@Application/Security/Authentications/Actions/recoveryCodesDownloaded';
import { downloadBlob } from '@Infra/Download';
import type * as React from 'react';

const RECOVERY_CODES_FILENAME = 'codes-de-recuperation-dixit.txt';

/**
 * A purely local side effect — triggering a browser download of the codes shown once on the
 * enrollment screen — with no server call and no business payload beyond confirming it happened:
 * the exact case the application layer guide covers for a file export, where an action is still
 * dispatched and returned rather than `Promise<void>`.
 */
export default (recoveryCodes: readonly string[]) => {
	return async (
		dispatch: React.Dispatch<RecoveryCodesDownloadedAction>,
	): Promise<RecoveryCodesDownloadedAction> => {
		const blob = new Blob([recoveryCodes.join('\n')], { type: 'text/plain' });
		downloadBlob(blob, RECOVERY_CODES_FILENAME);

		const action = recoveryCodesDownloaded();
		dispatch(action);
		return action;
	};
};
